import { render } from "./Mens.vue?vue&type=template&id=eefc84d0"
import script from "./Mens.vue?vue&type=script&lang=js"
export * from "./Mens.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__